<template>
  <transition name="modal">
    <div
      v-if="showModal"
      :id="modalId"
      class="modal block"
      tabindex="-1"
      aria-modal="true"
      role="dialog"
    >
      <div class="modal-dialog flex flex-col my-0 mx-auto w-100 mw-100">
        <div
          class="modal-content min-vh-100 border-0 rounded-0"
          :class="[paddingClass, backgroundColor]"
        >
          <slot />
        </div>
      </div>
    </div>
  </transition>

  <transition name="backdrop">
    <div
      v-if="showModal"
      class="modal-backdrop"
      @click="modalStore.closeModal"
    />
  </transition>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useModalStore } from '@/stores/ModalStore'

const props = defineProps({
  backgroundColor: {
    type: String,
    default: 'bg-primary-450',
    validator: (value) => value.includes('bg-'),
  },

  paddingClass: {
    type: String,
    default: 'px-3 py-2',
  },

  modalId: {
    type: String,
    required: true,
  },
})

const route = useRoute()

const modalStore = useModalStore()
const { getId } = storeToRefs(modalStore)
const showModal = computed(() => getId.value === props.modalId)
watch(
  () => route.fullPath,
  () => {
    modalStore.closeModal()
  }
)
</script>
